export default class ErrorMonitor {
  id: string;

  contractExternalId: string;

  customerName: string;

  type: string;

  stackTrace: string;

  description: string;

  integrationJson: string;

  createdDate: string;

  constructor(obj: any) {
    this.id = obj.id || 0;
    this.contractExternalId = obj.contractExternalId || '';
    this.customerName = obj.customerName || '';
    this.type = obj.type || '';
    this.stackTrace = obj.stackTrace || '';
    this.description = obj.description || '';
    this.integrationJson = obj.integrationJson || '';
    this.createdDate = obj.createdDate || '';
  }

  public static of(obj: any): ErrorMonitor {
    return new ErrorMonitor(obj || {})
  }

  public static ofList(obj: any = []): ErrorMonitor[] {
    return obj.map(this.of)
  }
}
